"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pacman = void 0;

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

var _map = require("rxjs/operators/map");

var _bufferWhen = require("rxjs/operators/bufferWhen");

var _filter = require("rxjs/operators/filter");

var _debounceTime = require("rxjs/operators/debounceTime");

var _first = require("rxjs/operators/first");

var _merge = require("rxjs/observable/merge");

var _fromEvent = require("rxjs/observable/fromEvent");

var _from = require("rxjs/observable/from");

var _interval = require("rxjs/observable/interval");

var _empty = require("rxjs/observable/empty");

var _zip = require("rxjs/observable/zip");

var _ReplaySubject = require("rxjs/ReplaySubject");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// (Homam:) I disabled canvasHash for now, we can get it back by un-commenting the lines prefixed with //CanvasHash:
//CanvasHash: import md5 from './md5';
//CanvasHash: import canvasHash from './canvasHash';
var Pacman = /*#__PURE__*/function () {
  // check webpack.config.common.js
  function Pacman(w, visitor, startTime) {
    _classCallCheck(this, Pacman);

    _defineProperty(this, "flow_event", void 0);

    _defineProperty(this, "custom", void 0);

    _defineProperty(this, "flowEventNumber", void 0);

    _defineProperty(this, "batch", void 0);

    _defineProperty(this, "rockmanId", void 0);

    _defineProperty(this, "impressionNumber", void 0);

    _defineProperty(this, "startTime", void 0);

    _defineProperty(this, "serverUrl", process.env.pacman_server);

    _defineProperty(this, "d", void 0);

    _defineProperty(this, "w", void 0);

    this.flowEventNumber = 1;
    this.batch = 0;
    this.d = w.document;
    this.w = w;
    this.rockmanId = visitor.rockmanId;
    this.impressionNumber = visitor.impressionNumber;
    this.startTime = startTime;
  }

  _createClass(Pacman, [{
    key: "initInteractions",
    value: function initInteractions() {
      var thisLocal = this;
      var w = this.w;
      var d = this.d;
      var documentProp = new DocumentProp(w);
      var visibilityProperty = "hidden",
          visibilityChangeEvent;
      if (visibilityProperty in d) visibilityChangeEvent = "visibilitychange";else if ((visibilityProperty = "mozHidden") in d) visibilityChangeEvent = "mozvisibilitychange";else if ((visibilityProperty = "webkitHidden") in d) visibilityChangeEvent = "webkitvisibilitychange";else if ((visibilityProperty = "msHidden") in d) visibilityChangeEvent = "msvisibilitychange";
      var visibilities = visibilityChangeEvent ? (0, _fromEvent.fromEvent)(d, visibilityChangeEvent).pipe((0, _map.map)(function () {
        return {
          t: d[visibilityProperty] ? "hidden" : "visible",
          s: thisLocal.getRelativeTime()
        };
      })) : (0, _empty.empty)();
      var unload = (0, _fromEvent.fromEvent)(w, "beforeunload");
      var blur = (0, _fromEvent.fromEvent)(w, "blur").pipe((0, _map.map)(function () {
        return {
          t: "blur",
          s: thisLocal.getRelativeTime(),
          a: {
            e: "window"
          }
        };
      }));
      var focus = (0, _fromEvent.fromEvent)(w, "focus").pipe((0, _map.map)(function () {
        return {
          t: "focus",
          s: thisLocal.getRelativeTime(),
          a: {
            e: "window"
          }
        };
      }));
      var focusin = (0, _fromEvent.fromEvent)(d, "focusin").pipe((0, _map.map)(function (event) {
        return {
          t: "focus",
          s: thisLocal.getRelativeTime(),
          a: {
            e: documentProp.getEventTarget(event).id
          }
        };
      }));
      var focusout = (0, _fromEvent.fromEvent)(d, "focusout").pipe((0, _map.map)(function (event) {
        return {
          t: "blur",
          s: thisLocal.getRelativeTime(),
          a: {
            e: documentProp.getEventTarget(event).id
          }
        };
      }));
      var submit = (0, _fromEvent.fromEvent)(d, "submit").pipe((0, _map.map)(function (event) {
        return {
          t: "submit",
          s: thisLocal.getRelativeTime(),
          a: {
            e: documentProp.getEventTarget(event).id
          }
        };
      }));
      var firstChange = (0, _fromEvent.fromEvent)(d, "change").pipe((0, _map.map)(function (event) {
        return {
          t: "fchange",
          s: thisLocal.getRelativeTime(),
          a: {
            e: documentProp.getEventTarget(event).id
          }
        };
      }), (0, _first.first)());
      var firstTouch = (0, _fromEvent.fromEvent)(d, "touchstart").pipe((0, _map.map)(function () {
        return {
          t: "ftouch",
          s: thisLocal.getRelativeTime()
        };
      }), (0, _first.first)());
      var firstMotion = (0, _fromEvent.fromEvent)(w, "devicemotion").pipe((0, _map.map)(function () {
        return {
          t: "fmotion",
          s: thisLocal.getRelativeTime()
        };
      }), (0, _first.first)());
      var firstAccelerationIncludingGravity;
      var firstMotion = (0, _fromEvent.fromEvent)(w, 'devicemotion').pipe((0, _map.map)(function (event) {
        return event.accelerationIncludingGravity;
      }), (0, _first.first)(function (event) {
        if (firstAccelerationIncludingGravity) {
          return !!(Math.abs(firstAccelerationIncludingGravity.x - event.x) > 0.2 || Math.abs(firstAccelerationIncludingGravity.y - event.y) > 0.2 || Math.abs(firstAccelerationIncludingGravity.z - event.z) > 0.2);
        } else {
          firstAccelerationIncludingGravity = event;
          return false;
        }
      })).pipe((0, _map.map)(function () {
        return {
          "t": 'fmotion',
          "s": thisLocal.getRelativeTime()
        };
      }));
      var full_load = (0, _fromEvent.fromEvent)(w, "load").pipe((0, _map.map)(function () {
        return {
          t: "full_load",
          s: thisLocal.getRelativeTime(),
          a: {
            p: documentProp.getViewportSize()
          }
        };
      }));
      var html_load;

      if (this.d.readyState === "complete" || this.d.readyState === "interactive") {
        html_load = (0, _from.from)([{
          t: "html_load",
          s: thisLocal.getRelativeTime(),
          a: {
            p: documentProp.getViewportSize()
          }
        }]);
      } else {
        html_load = (0, _fromEvent.fromEvent)(d, "DOMContentLoaded").pipe((0, _map.map)(function () {
          return {
            t: "html_load",
            s: thisLocal.getRelativeTime(),
            a: {
              p: documentProp.getViewportSize()
            }
          };
        }));
      }

      this.flow_event = new _ReplaySubject.ReplaySubject();
      var touchstart = (0, _fromEvent.fromEvent)(d, "touchstart");
      var touchend = (0, _fromEvent.fromEvent)(d, "touchend");
      this.custom = new _ReplaySubject.ReplaySubject();
      /*CanvasHash:
      var fp_canvas = Observable.create(function (observer) {
        if (w.requestIdleCallback) {
          w.requestIdleCallback(function () {
            observer.next({
              "t": 'fp_canvas',
              "s": thisLocal.getRelativeTime(),
              "a": {
                "e": md5(canvasHash())
              }
            })
          })
        } else {
          setTimeout(function () {
            observer.next({
              "t": 'fp_canvas',
              "s": thisLocal.getRelativeTime(),
              "a": {
                "e": md5(canvasHash())
              }
            })
          }, 700)
         }
      });
      */

      var clicks = (0, _zip.zip)(touchstart, touchend).pipe((0, _filter.filter)(function (x) {
        return x[1].timeStamp - x[0].timeStamp < 350 && x[0].touches.length == 1 && x[1].touches.length == 0;
      }), (0, _map.map)(function (event) {
        return {
          t: "click",
          s: thisLocal.getRelativeTime(),
          a: {
            e: documentProp.getEventTarget(event[0].touches[0]).id,
            p: documentProp.getEventPos(event[0].touches[0])
          }
        };
      }));
      var scrolls = (0, _fromEvent.fromEvent)(w, "scroll").pipe((0, _debounceTime.debounceTime)(500), (0, _map.map)(function (event) {
        return {
          t: event.type,
          s: thisLocal.getRelativeTime(),
          a: {
            p: documentProp.getDocumentScroll()
          }
        };
      }));
      var resize = (0, _fromEvent.fromEvent)(w, "resize").pipe((0, _debounceTime.debounceTime)(500), (0, _map.map)(function (event) {
        return {
          t: event.type,
          s: thisLocal.getRelativeTime(),
          a: {
            p: documentProp.getViewportSize()
          }
        };
      }));
      var stream = (0, _merge.merge)(clicks, scrolls, blur, focus, focusin, focusout, visibilities, firstTouch, firstChange, firstMotion, submit, resize, full_load, html_load, //CanvasHash: fp_canvas,
      this.flow_event, this.custom).pipe((0, _bufferWhen.bufferWhen)(function () {
        return (0, _merge.merge)((0, _interval.interval)(7000), unload, blur);
      }), (0, _filter.filter)(function (x) {
        return x.length > 0;
      }));
      stream.subscribe(function (data) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", thisLocal.serverUrl, true);
        xhr.send(JSON.stringify({
          r: thisLocal.rockmanId,
          m: thisLocal.impressionNumber,
          b: thisLocal.batch++,
          d: data
        }));
      });
    }
  }, {
    key: "sendPageview",
    value: function sendPageview() {
      var thisLocal = this;
      var w = this.w;
      var d = this.d;
      var n = this.w.navigator;
      var vp = "hidden";
      vp in d || (vp = "mozHidden") in d || (vp = "webkitHidden") in d || (vp = "msHidden") in d;

      var r = function r(f) {
        try {
          var o = f.apply(this, arguments);
          return _typeof(o) == _typeof(true) ? +o : o;
        } catch (e) {
          return null;
        }
      },
          ua = n.userAgent.toLowerCase(),
          re = "CSS1Compat" == document.compatMode ? document.documentElement : document.body || document.documentElement,
          pv = {
        t: "pageview",
        s: 0,
        tz: -new Date().getTimezoneOffset(),
        n: r(function () {
          return Notification.permission;
        }),
        f: r(function () {
          return w.top != w.self;
        }),
        nt: r(function () {
          return n.connection.type || null;
        }),
        ns: r(function () {
          return n.connection.effectiveType || null;
        }),
        l: r(function () {
          var a = w.navigator ? n.language || n.userLanguage || n.browserLanguage || n.systemLanguage : null;
          return "[object String]" == Object.prototype.toString.call(a) ? a.toLowerCase() : null;
        }),
        lz: r(function () {
          return n.languages.join(" ").toLowerCase();
        }),
        vw: r(function () {
          return re.clientWidth || w.innerWidth;
        }),
        vh: r(function () {
          return re.clientHeight || w.innerHeight;
        }),
        sw: r(function () {
          return w.screen.width;
        }),
        sh: r(function () {
          return w.screen.height;
        }),
        sd: w.screen.colorDepth || null,
        sr: w.devicePixelRatio || null,
        np: r(function () {
          return n.platform || null;
        }),
        dnt: r(function () {
          if (typeof n.doNotTrack !== "undefined" && n.doNotTrack !== null) {
            if (n.doNotTrack == "yes") {
              return true;
            } else if (n.doNotTrack == "no") {
              return false;
            }

            return !!n.doNotTrack;
          } else if (typeof w.doNotTrack !== "undefined" && w.doNotTrack !== null) {
            return !!w.doNotTrack;
          }

          return null;
        }),
        c: r(function () {
          return n.cookieEnabled;
        }),
        ss: r(function () {
          return !!w.sessionStorage;
        }),
        wd: r(function () {
          return !!n.webdriver;
        }),
        ls: r(function () {
          return !!w.localStorage;
        }),
        ib: r(function () {
          return !!w.indexedDB;
        }),
        od: r(function () {
          return !!w.openDatabase;
        }),
        hf: r(function () {
          return !!d.hasFocus();
        }),
        iv: r(function () {
          return !!!d[vp];
        }),
        ll: r(function () {
          return n.languages[0].substr(0, 2) !== n.language.substr(0, 2);
        }),
        lr: r(function () {
          return w.screen.width < w.screen.availWidth || w.screen.height < w.screen.availHeight;
        }),
        lo: r(function () {
          var p = n.platform.toLowerCase();
          if (ua.indexOf("windows phone") >= 0 || ua.indexOf("win") >= 0) return null;
          if (ua.indexOf("android") >= 0) return typeof n.plugins === "undefined" || p.indexOf("win") >= 0 || p.indexOf("mac") >= 0 || p.indexOf("ipad") >= 0 || p.indexOf("ipod") >= 0 || p.indexOf("iphone") >= 0;
          if (ua.indexOf("linux") >= 0) return null;
          if (ua.indexOf("iphone") >= 0 || ua.indexOf("ipad") >= 0) return typeof n.plugins === "undefined" || p.indexOf("win") >= 0 || p.indexOf("linux") >= 0 || p.indexOf("android") >= 0 || p.indexOf("pike") >= 0;
          return null;
        }),
        lb: r(function () {
          var ps = n.productSub,
              t = eval.toString().length;
          if (ua.indexOf("firefox") >= 0) return t !== 37;
          if (ua.indexOf("opera") >= 0 || ua.indexOf("opr") >= 0) return ps !== "20030107" || t !== 33;
          if (ua.indexOf("chrome") >= 0) return ps !== "20030107" || t !== 33;
          if (ua.indexOf("safari") >= 0) return ps !== "20030107" || t !== 37;
          if (ua.indexOf("trident") >= 0) return t !== 39;
          return null;
        })
      };

      var xhr = new XMLHttpRequest();
      xhr.open("POST", thisLocal.serverUrl, true);
      xhr.send(JSON.stringify({
        r: thisLocal.rockmanId,
        m: thisLocal.impressionNumber,
        b: thisLocal.batch++,
        d: [{
          t: "pageview",
          s: 0,
          a: pv
        }]
      }));
    }
  }, {
    key: "sendFlowEvent",
    value: function sendFlowEvent(flowEvent) {
      this.flow_event.next({
        t: 'flow_event',
        s: this.getRelativeTime(),
        a: _objectSpread({
          number: this.flowEventNumber++
        }, flowEvent)
      });
    }
  }, {
    key: "sendCustomEvent",
    value: function sendCustomEvent(typeName, eventName) {
      this.custom.next({
        t: typeName,
        s: this.getRelativeTime(),
        a: {
          e: eventName
        }
      });
    }
  }, {
    key: "getRelativeTime",
    value: function getRelativeTime() {
      return precisionRound((this.startTime ? new Date().valueOf() - this.startTime : 0) / 1000, 1);
    }
  }]);

  return Pacman;
}();

exports.Pacman = Pacman;

function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}

;

var DocumentProp = /*#__PURE__*/function () {
  function DocumentProp(w) {
    _classCallCheck(this, DocumentProp);

    _defineProperty(this, "d", void 0);

    _defineProperty(this, "w", void 0);

    this.d = w.document;
    this.w = w;
  }

  _createClass(DocumentProp, [{
    key: "getRootElement",
    value: function getRootElement() {
      var element = this.d.documentElement;
      return "CSS1Compat" == this.d.compatMode ? element : this.d.body || element;
    }
  }, {
    key: "getViewportSize",
    value: function getViewportSize() {
      var rootElement = this.getRootElement();
      return [rootElement.clientWidth || this.w.innerWidth, rootElement.clientHeight || this.w.innerHeight];
    }
  }, {
    key: "getDocumentScroll",
    value: function getDocumentScroll() {
      return [this.w.pageXOffset || this.d.documentElement && this.d.documentElement.scrollLeft || this.d.body && this.d.body.scrollLeft || 0, this.w.pageYOffset || this.d.documentElement && this.d.documentElement.scrollTop || this.d.body && this.d.body.scrollTop || 0];
    }
  }, {
    key: "getEventPos",
    value: function getEventPos(event) {
      var b = this.getRootElement(),
          c = this.getDocumentScroll();
      return [event.pageX || event.clientX + c[0] - (b.clientLeft || 0) || 0, event.pageY || event.clientY + c[1] - (b.clientTop || 0) || 0];
    }
  }, {
    key: "getEventTarget",
    value: function getEventTarget(event) {
      var b = null;

      try {
        (b = event.target || event.srcElement) && !b.ownerDocument && b.documentElement && (b = b.documentElement);
      } catch (c) {}

      return b;
    }
  }]);

  return DocumentProp;
}();

;